// The individual annual Platinum rates the client displays — the same numbers
// as lib/membershipPricing.js on the server, which is the only authority for
// what a member is actually charged. __tests__/unit/lib/membershipPricing.test.js
// fails if the two files disagree.
//
// RM-347 (Kapil 2026-09-29): regular rate $400 (new joins, expired members
// rejoining); the renewal rate for an active member extending a year stays $200.
export const REGULAR_ANNUAL_PRICE_DOLLARS = 400
export const EXTENSION_PRICE_DOLLARS = 200
